import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";
import { AmplifyProvider } from "./contexts/AmplifyContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <AmplifyProvider>
      <App />
    </AmplifyProvider>
  </React.StrictMode>,
);
